import { render } from "./SidePanel.vue?vue&type=template&id=3389beb4&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=3389beb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3389beb4"]])

export default __exports__